import { ComponentType } from 'react';

import Loadable from '@townsquare/loadable';
import { RouteContext } from '@townsquare/router/routing-types';

export const FollowProjectAction: ComponentType<RouteContext> & LoadableExport.LoadableComponent =
	Loadable({
		loader: () => import(/* webpackChunkName: "FollowProjectAction" */ './FollowProjectAction'),
		loading: () => null,
	});
